import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { MessageTemplate } from "../../model/message-template.model";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { GROUP_ITEMS, OCCASION_ITEMS, MessageTemplateType } from "../../messaging-tokens";
import { takeUntil } from "rxjs/operators";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { Lookup } from "projects/sepidz-web-framework/src/lib/models";

@Component({
  selector: "ngx-message-template-form",
  templateUrl: "./message-template-form.component.html",
  styleUrls: ["./message-template-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageTemplateFormComponent extends BaseFormComponent<MessageTemplate> {
  occasionItems: NameValue[] = OCCASION_ITEMS;
  groupItems: NameValue[] = GROUP_ITEMS;
  messageTemplateType = MessageTemplateType;
  occasionMessageTemplate: Lookup;
  groupMessageTemplate: Lookup;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private lookupservice: LookupService) {
    super(selectorService, cd);
    this.FillData();
  }

  async ngOnInit() {
    this.apiName = "MessageTemplate";
    this.label = this.translate("ClientApp.FrontOffice.Messaging.TemplateMessage.MessagePlatform");
    super.ngOnInit();
  }
  ngOnChanges() {
    if (this.model.IsDefault) {
      this.formGroup.get("MessageTemplateTypeId").disable();
    } else {
      this.formGroup.get("MessageTemplateTypeId").enable();
    }
  }
  async FillData() {
    if (!this.model.NumberOfDaysBeforeSending) this.model.NumberOfDaysBeforeSending = 0;
    if (!this.model.MessageTemplateTypeTitle) {
      this.lookupservice
        .getLookupbyCategory("SALE", "MessageTemplateType")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(async (x) => {
          this.occasionMessageTemplate = x.find((c) => c.Code === MessageTemplateType.occasion);
          this.groupMessageTemplate = x.find((c) => c.Code === MessageTemplateType.groups);
          this.model.MessageTemplateTypeId = this.occasionMessageTemplate?.Id;
          this.model.MessageTemplateTypeCode = this.occasionMessageTemplate?.Code;
          this.model.MessageTemplateTypeTitle = this.occasionMessageTemplate?.Title;
          this.setValue("MessageTemplateTypeId", this.occasionMessageTemplate?.Id);
          if (this.model.IsDefault) this.formGroup.controls["MessageTemplateTypeId"].disable();
          this.setValue("MessageTemplateTypeCode", this.occasionMessageTemplate?.Code);
          this.setValue("MessageTemplateTypeTitle", this.occasionMessageTemplate?.Title);
        });
    }
  }
  setdefault() {
    if (this.model && !this.model.Id) {
      //اگر در مد ایجاد بودیم
      this.model.IsActive = true;
    }
    if (!this.formGroup) this.setFormGroup(this.model);
  }
  addControl() {
    if (this.formGroup) {
      this.setValue("Text", this.model.Text);
    }
    this.orignalColumns.forEach((x) => {
      if (x.name == "NumberOfDaysBeforeSending") {
        x.formVisible = this.model.MessageTemplateTypeCode === MessageTemplateType.occasion;
        this.columns = this.orignalColumns.filter(
          (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
        );
        this.columns = this.columns.sort((a, b) => a.order - b.order);
        this.cd.markForCheck();
      }
    });
  }
  isValid(): boolean {
    let flag = true;
    if(!this.formGroup.controls["Text"].value)
    {
      flag = false;
      this.sts.showToast("danger", "", this.translate("ClientApp.FrontOffice.Messaging.TemplateMessage.InvalidText"));
    }
    return flag;
  }
  valueChange(event: any) {
    if (this.model.IsDefault && event === this.groupMessageTemplate?.Id) {
      this.model.MessageTemplateTypeId = this.occasionMessageTemplate?.Id;
      this.model.MessageTemplateTypeCode = this.occasionMessageTemplate?.Code;
      this.model.MessageTemplateTypeTitle = this.occasionMessageTemplate?.Title;
      this.setValue("MessageTemplateTypeId", this.occasionMessageTemplate?.Id);
      this.setValue("MessageTemplateTypeCode", this.occasionMessageTemplate?.Code);
      this.setValue("MessageTemplateTypeTitle", this.occasionMessageTemplate?.Title);
    } else {
      if ((event && event === this.occasionMessageTemplate?.Id) || event === this.groupMessageTemplate?.Id) {
        this.orignalColumns.forEach((x) => {
          if (x.name == "NumberOfDaysBeforeSending") {
            x.formVisible = event === this.occasionMessageTemplate?.Id;
            this.columns = this.orignalColumns.filter(
              (f) =>
                ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
            );
            this.columns = this.columns.sort((a, b) => a.order - b.order);
            this.cd.markForCheck();
          }
        });
      }
    }
  }
  ngAfterViewInit(): void {
    this.FillData();
  }
}
